import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LangContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mm-footer" data-testid="site-footer">
      <div className="container-mm">
        <div className="grid">
          <div>
            <div className="brand">МЕД<em>МИР</em></div>
            <p className="desc">{t.footer.tagline}</p>
          </div>
          <div>
            <h5>{t.footer.nav_title}</h5>
            <Link to="/about">{t.nav.about}</Link>
            <Link to="/services">{t.nav.services}</Link>
            <Link to="/products">{t.nav.products}</Link>
            <Link to="/quality">{t.nav.quality}</Link>
            <Link to="/how-we-work">{t.nav.how}</Link>
            <Link to="/geography">{t.nav.geo}</Link>
          </div>
          <div>
            <h5>{t.footer.contacts_title}</h5>
            <a href="mailto:info@medmir.llc">info@medmir.llc</a>
            <a href="tel:+992118111786">+992 11 811 17 86</a>
            <a href="/contacts">{t.contacts.address_value}</a>
          </div>
          <div>
            <h5>{t.footer.legal_title}</h5>
            <p style={{ color: 'rgba(246,242,235,0.55)', fontSize: 12, lineHeight: 1.5 }}>
              {t.footer.legal_note}
            </p>
          </div>
        </div>

        <div className="base">
          <span>{t.footer.copyright}</span>
          <span>Dushanbe · TJ / RU / EN</span>
        </div>
      </div>
    </footer>
  );
}
